import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import type { ResultOf } from 'gql.tada';

// Ruling 26: read-only against Stripe. It settles rows Stripe has already
// collected, points rows at Stripe invoices they were missing, and reports what
// Stripe has that SolaStack does not as history. It never voids anything.

const SyncFamilyBillingMutation = graphql.persisted(
  "SyncFamilyBilling",
  graphql(`
    mutation SyncFamilyBilling($input: SyncFamilyBillingInput!) {
      syncFamilyBilling(input: $input) {
        success
        report {
          settledCount
          stampedCount
          warnings
          history {
            stripeInvoiceId
            number
            status
            amountPaid
            periodStart
            periodEnd
            hostedUrl
            description
            otherSchoolYearName
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export type SyncFamilyBillingReport = NonNullable<
  ResultOf<typeof SyncFamilyBillingMutation>['syncFamilyBilling']
>['report'];

export type StripeInvoiceHistoryRow = NonNullable<SyncFamilyBillingReport>['history'][number];

export { SyncFamilyBillingMutation };

export function useSyncFamilyBilling() {
  return useMutation(SyncFamilyBillingMutation);
}
